import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';
import {
  DataTable,
  DataTableItem,
  Loader,
  SectionHeader,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  getAllSellVatsAsync,
  selectSellVats,
  selectSellVatsLoadingStatus,
  AccountingsQueryFilters,
} from './accountingSlice';
import { LOADING_STATUS } from '../../common/constants';

function SellVats() {
  const dispatch = useAppDispatch();
  const [hasSearchBeenMade, setHasSearchBeenMade] = useState<boolean>(false);
  const sellvats = useAppSelector(selectSellVats);
  const sellvatsLoadingStatus = useAppSelector(selectSellVatsLoadingStatus);
  const [filtering, setFiltering] = useState<AccountingsQueryFilters>({
    pageSize: 200,
    pageNumber: 1,
    culture: 'fi_FI',
  });
  const [sellvatsListItems, setSellvatsListItems] = useState<DataTableItem[]>(
    [],
  );

  // calls actual search, which calls internal getAllSellVatsAsync Async
  // and that is then routed to backend
  const doSearch = () => {
    dispatch(getAllSellVatsAsync(filtering));
  };

  useEffect(() => {
    doSearch();
    setHasSearchBeenMade(true);
  }, []);

  useEffect(() => {
    if (sellvats && sellvats.length > 0) {
      const formattedSellvatsList: DataTableItem[] = [];
      sellvats?.forEach(item => {
        formattedSellvatsList.push({
          ItemId: item.id,
          Items: [item.name],
          Url: `/accounting/sellvats/details/${item.id}`,
        });
      });
      setSellvatsListItems(formattedSellvatsList);
    }
  }, [sellvats]);

  // draws elements to browser
  return (
    <>
      <Helmet>
        <title>Myynti alv - Haku</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Kirjanpito ja Alv-määritykset']}
          Title="Myynti alv - Haku"
        />

        <Loader IsLoading={sellvatsLoadingStatus === LOADING_STATUS.LOADING} />

        {sellvatsLoadingStatus === LOADING_STATUS.IDLE &&
          sellvatsListItems.length > 0 && (
            <DataTable Header={['Nimi']} Items={sellvatsListItems} />
          )}

        {sellvatsLoadingStatus === LOADING_STATUS.IDLE &&
          sellvatsListItems.length < 1 &&
          hasSearchBeenMade && <p>Ei Alv määrityksiä.</p>}
      </Container>
    </>
  );
}

export default SellVats;
